const getters = {
  getQuoteList: (state) => {
    return state.quotes
  },
  getQuoteListFetching: (state) => {
    return state.isFetching
  },
  getQuoteListError: (state) => {
    return state.errors
  },
  getIfOneOfQuotesIsAccepted: (state) => {
    if (state.quotes != null) {
      if (state.quotes.length > 1) {
        const index = state.quotes.findIndex(({ status }) =>  status === 'Accepted')
        return index >= 0
      }
    }
    return false
  }
}

export default getters
